import { render, staticRenderFns } from "./LampDesk.vue?vue&type=template&id=2e6c7de3&"
import script from "./LampDesk.vue?vue&type=script&lang=js&"
export * from "./LampDesk.vue?vue&type=script&lang=js&"
import style0 from "./LampDesk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports